module.exports = __webpack_public_path__ + "img/poster_element_wo_shadow.39990848.png";